module.exports = __webpack_public_path__ + "img/shangcheng.8026b2f3.png";